import React from "react";
import { FixedColumn } from "../common/Flex";
import styled from "styled-components";
import { breakpoints } from "../../breakpoints";

export const LogoBox = styled(FixedColumn).attrs({width:"200px"})
`
    margin-right:1rem;
    display: flex;
    flex-direction: column;

    @media (max-width: ${breakpoints.maxWidthXs}) {
        flex: 0 0 100%;
        width: 100%;
        margin-bottom: 1rem;
    }
`;

export const Logo = styled.img`
height:104px;
max-width: 200px;
`;